<template>
<div>
    <Header />
    <div class="desktop">
        <div class="content-container text-white">
            <div class="text-center">
                <h2 class="bg-text-title text-white">CULTURE SQUARE </h2>
                <p class="space30 text-white bg-sub-text">
                    Connecting you to the best cultural experiences around the world
                </p>
                <InputBox class="mt-lg-5 mt-sm-0 " @handleSearch="SearchExplore" />
                <div class="flex-content desktop non_ipad non_tab">
                    <div class="notification-box" v-for="(note, index) in notes" :key="index">
                        <font-awesome-icon :icon="['far', 'bookmark']" class="mr" /> {{note.user_name}} {{note.action}} <strong>
                            <router-link class="text-white" :to="navigate(note)"> {{note.event_name}} </router-link>
                        </strong>
                    </div>
                </div>
                <div class="flex-content mobile">
                    <div class="notification-box" v-for="(note, index) in mobileNotes" :key="index">
                        <font-awesome-icon :icon="['far', 'bookmark']" class="mr" /> {{note.user_name}} {{note.action}} <strong>
                            <router-link class="text-white" :to="{ name: 'listing-details', params: {id: note.event_id} }"> {{note.event_name}} </router-link>
                        </strong>
                    </div>
                </div>

            </div>

        </div>
        <div class="video-hero text-white">
            <div class="video-container">
                <video playsinline autoplay muted loop width="100%" height="auto" id="hero-video">
                    <source src="../assets/images/video.mp4" type="video/mp4" />
                </video>
            </div>
            <div class="overlay"></div>

        </div>
    </div>
    <div class="mobile">
        <div class="video-hero text-white">
            <div class="video-container">
                <video playsinline autoplay muted loop width="100%" height="auto" id="hero-video">
                    <source src="../assets/images/video.mp4" type="video/mp4" />
                </video>
            </div>
            <div class="overlay"></div>
        </div>
        <div class="content-container text-white">
            <div class="text-center">
                <h2 class="bg-text-title text-white">CULTURE SQUARE </h2>
                <p class="space30 text-white bg-sub-text">
                    Connecting you to the best cultural experiences around the world
                </p>
                <InputBox class="mt-lg-5 mt-sm-0 " @handleSearch="SearchExplore" />
                <div class="flex-content desktop">
                    <div class="notification-box" v-for="(note, index) in notes" :key="index">
                        <font-awesome-icon :icon="['far', 'bookmark']" class="mr" /> {{note.user_name}} {{note.action}} <strong>
                            <router-link class="text-white" :to="{ name: 'listing-details', params: {id: note.event_id} }"> {{note.event_name}} </router-link>
                        </strong>
                    </div>
                </div>
                <div class="flex-content mobile">
                    <div class="notification-box" v-for="(note, index) in mobileNotes" :key="index">
                        <font-awesome-icon :icon="['far', 'bookmark']" class="mr" /> {{note.user_name}} {{note.action}} <strong>
                            <router-link class="text-white" :to="{ name: 'listing-details', params: {id: note.event_id} }"> {{note.event_name}} </router-link>
                        </strong>
                    </div>
                </div>

            </div>

        </div>

    </div>
    <BodyLinks />
    <div class="text-center ">
        <p class="main-text">ALL-AROUND CULTURAL EXPERIENCE</p>
        <p class="sub-main-text">
            Connecting you to the most exciting cultural events around the world
        </p>
    </div>
    <b-container class="bv-example-row mt-lg-5 mt-sm-0">
        <b-row class="mt-lg-5 mt-sm-0 ">
            <b-col cols="12" md="4" class="services">
                <div class="service text-center">
                    <img src="../assets/images/host_event.gif" alt="">
                    <p class="services-title text-center">
                        Host Events
                    </p>
                    <p class="services-sub-title text-center">
                        Create events as a host for people to attend
                    </p>
                    <p>
                        <font-awesome-icon :icon="['fas', 'arrow-right']" />
                    </p>
                    <div class="service-details host-service-details mb-4">
                        <p><img class="service-details-img" src="../assets/images/attend-event.svg" alt=""> Host Event</p>
                        <ul class="mt-4 font14">
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Subscribe to become a member </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Create an event to be hosted online or at a physical location </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>
                                    Generate a passive income or receive gifts by hosting for free your cultural events
                                </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Invite or accept invite from Culture Square members.
                                </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Exchange gifts and Souvenirs with your guests that define your experience. </span>
                            </li>

                        </ul>
                        <p class="float-right">
                            <router-link to="/listings/events/create">
                                <b-icon icon="arrow-right"></b-icon>
                            </router-link>
                        </p>
                    </div>
                </div>

            </b-col>
            <b-col cols="12" md="4" class="services">
                <div class="service text-center">
                    <img src="../assets/images/attend_event.gif" alt="">
                    <p class="services-title">
                        Attend Events
                    </p>
                    <p class="services-sub-title">
                        Be a guest at one of exciting events alround the world
                    </p>
                    <p>
                        <font-awesome-icon :icon="['fas', 'arrow-right']" />
                    </p>
                    <div class="service-details attend-service-details mb-4">
                        <p><img class="service-details-img" src="../assets/images/event-note.svg" alt=""> Attend Event</p>
                        <ul class="mt-4 font14">
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Sign up to become a member and create your profile </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Get invited or send an invite any where in the world to connect to a culture of your choice </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>
                                    Meet really people online or physically for unique cultural experiences
                                </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Learning how to cook an exotic dish or
                                    speak a foreign language. </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Exchange gifts and Souvenirs with your hosts that define you experience for eternity. </span>
                            </li>

                        </ul>
                        <p class="float-right">
                            <router-link to="/listings/events">
                                <b-icon icon="arrow-right"></b-icon>
                            </router-link>
                        </p>
                    </div>
                </div>

            </b-col>
            <b-col cols="12" md="4" class="services">
                <div class="service text-center">
                    <img src="../assets/images/render_service.gif" alt="">
                    <p class="services-title">
                        Sell a Product / Service
                    </p>
                    <p class="services-sub-title">
                        Offer a local service to curious visitors and culture enthusiasts
                    </p>
                    <p>
                        <font-awesome-icon :icon="['fas', 'arrow-right']" />
                    </p>
                    <div class="service-details render-service-details mb-4">
                        <p><img class="service-details-img" src="../assets/images/cart.svg" alt="">Sell a Product/Service</p>
                        <ul class="mt-4 font14">
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Become a vendor </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Buy unique items </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>
                                    Educate us about the color and shape of your clothes
                                </span>
                            </li>
                            <li>
                                <b-icon icon="check2-all" font-scale="1.5" class="pr-2"></b-icon> <span>Show us the arts that inspired your childhood </span>
                            </li>

                        </ul>
                        <p class="float-right mt-5">
                            <a target="_blank" href="https://stores.culturesquare.com">
                                <b-icon icon="arrow-right"></b-icon>
                            </a>
                        </p>
                    </div>
                </div>

            </b-col>
        </b-row>
    </b-container>
    <BlackBox class="mt-5 desktop" :images="images" />
    <WhiteBox class="mt-5 mobile" :images="images" />
    <div class="text-center mb-2 position-relative">
        <div class="img-gif-1 desktop"><img src="../assets/images/dot_file.gif" alt=""></div>
        <p class="main-text">are you thrilled</p>

        <p class="sub-main-text">
            We are excited to have you share your cultural experience with us
        </p>
        <div class="mt-5 mb-5">
            <router-link to="/accounts/signup" class="btn btn-warning text-white">Sign Up
                <font-awesome-icon :icon="['fas', 'arrow-right']" />
            </router-link>
        </div>
        <div class="img-gif-2 desktop"><img src="../assets/images/dot_file.gif" alt=""></div>

    </div>
    <Footer />
</div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import InputBox from "@/components/InputBox.vue";
import BlackBox from "@/components/BlackBox.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Footer from "@/components/Footer.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import axios from "axios";
import {
    getBaseUrl,
    getStoreBaseUrl
} from "../../utils/common";
const base_url = getBaseUrl()
const store_url = getStoreBaseUrl();
export default {
    name: "Home",
    components: {
        Header,
        InputBox,
        WhiteBox,
        BlackBox,
        BodyLinks,
        Footer
    },
    data: function () {
        return {
            openDrop: false,
            showByIndex: false,
            notes: [],
            mobileNotes: [],
            polling: null,
            images: []
        }
    },
    mounted() {
        this.pollData();
        this.getStoreImages();
    },
    methods: {
        SearchExplore(text) {
            if (text === null || text === '') {
                alert('enter a search keyword')
            } else {
                this.$router.push({
                    name: "listings",
                    params: {
                        name: text,
                        keyword: text
                    },
                });
            }
        },
        async getEventNotification() {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/activities`,
                    method: "GET",
                    params: {
                        snf: 1
                    },
                })
                this.notes = resp.data.data.slice(0, 2);
                this.mobileNotes = resp.data.data.slice(0, 1)
            } catch (error) {
                console.warn(error)
            }
        },
        async getStoreImages() {
            try {
                const resp = await axios({
                    url: `${store_url}/api/items`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: "GET",
                })
                const images = resp.data.data.sort(() => Math.random() - Math.random()).filter((prod) => {
                    return prod.image != null
                }).slice(0, 5)
                images.forEach(prod => {
                    prod.imgurl = 'https://s3-us-east-2.amazonaws.com/culturestores/' + prod.image
                });
                this.images = images
            } catch (error) {
                this.loading = false;
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        navigate(note) {
            if (note.event_type == 'event') {
                return {
                    name: 'listing-details',
                    params: {
                        id: note.event_id
                    }
                }
            } else if (note.event_type == 'course') {
                return {
                    name: 'language-event-details',
                    params: {
                        id: note.event_id
                    }
                }
            } else {
                return {
                    name: 'club-details',
                    params: {
                        id: note.event_id
                    }
                }
            }
        },
        pollData() {
            this.polling = setInterval(() => {
                this.getEventNotification()
            }, 10000)
        }
    },
    beforeDestroy() {
        clearInterval(this.polling)
    }
};
</script>

<style lang="scss" scoped>
.show {
    display: block;
}

.b-icon.bi {
    color: #F7B131 !important
}

.fa-bookmark {
    animation: color-change 2s infinite;
}

.img-gif-1 {
    position: absolute;
    top: -86px;
    left: 30px;
}

.img-gif-2 {
    position: absolute;
    bottom: -86px;
    right: 30px;
}

@keyframes color-change {
    0% {
        color: #F7B131;
    }

    50% {
        color: #fff;
    }

    100% {
        color: #F7B131;
    }
}

.bg-text-title {
    font-weight: 700;
    font-size: calc(2rem + 2px) !important;

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: calc(1rem + 6px) !important;

    }

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: calc(1rem) !important;

    }
}

.bg-sub-text {
    font-size: calc(1rem + 4px);
    font-weight: normal;

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: 1rem !important;

    }

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: calc(0.8rem) !important;

    }
}

.flex-content {
    display: flex;
    margin-top: 176px;
    justify-content: center;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 16px;
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 40px;

    }

    @media screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 76px;

    }
}

.btn-warning {
    padding: 10px 40px;
    border-radius: 4px !important;
}

.mr {
    margin-right: 6px
}

.notification-box {
    padding: 19px;
    background: rgba(0, 0, 0, 0.54);
    border-radius: 4px;
    margin: 0 20px;

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        display: none
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0 9rem;
    }

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        display: none
    }
}

.video-hero {
    width: 100%;
    min-height: 500px;
    max-height: 700px;
    overflow: hidden;
    margin-top: -90px;
    z-index: -100 !important;
    position: relative;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: -58px;
        position: absolute
    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        position: absolute;
        margin-top: -112px;
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: -182px;
        height: 530px;

    }

    @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: -265px;
        height: 530px;

    }

    @media screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: -124px;
        height: 600px;

    }
}

.video-hero .video-container {
    position: relative;
    width: 100%;
    height: 700px;
    // background-image: url('../assets/images/bg.jpg');
    background-size: cover;
    background-position: center center;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 118px;
        position: absolute;
    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 118px;
    }

    @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {

        height: 635px;

    }

}

.video-hero video {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: -1000;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        left: 50%;
        top: 4%;

    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        left: 50%;
        top: 4%;

    }

}

.content-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin-top: 209px;
    justify-content: center;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 0px;
        position: relative;
        padding-top: 10px
    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 65px;
        position: relative;
        top: -50px
    }

    @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) {
        margin-top: 54px;
        position: relative;
        top: -40px
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 125px;

    }

    @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 7em;

    }

    @media screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 185px;

    }
}

.services {
    height: 500px;
    padding-top: 70px;
    position: relative;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: auto;

    }

}

.services img {
    height: 130px
}

ul {
    padding-left: 0 !important
}

ul li {
    display: flex;
    align-items: center;
    margin: 5px auto
}

ul li span {
    padding-left: 15px
}

.service {
    position: relative;
}

.service-details {
    position: absolute;
    max-height: 500px;
    background: #FFFFFF;
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    border-radius: 24px;
    height: 0px;
    width: 100%;
    margin-left: -30px;
    margin-top: -350px;
    overflow: hidden;
    text-align: left !important;
    transition: all 1s ease-in-out;
}

.service:hover .host-service-details,
.service:hover .attend-service-details,
.service:hover .render-service-details {
    height: 470px;
    margin-left: 0px;
    padding: 2rem !important;
    border: 1px solid #F7B131;
}

.service-details p {
    font-size: 24px;
    font-weight: 500;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        font-size: 20px;

    }
}

.service-details-img {
    height: auto !important;
    width: 10%;
    margin: 0 12px 0 0;
    color: #F7B131
}

.services-title {
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.25px;
    text-transform: capitalize;
    color: #565C63;
    margin-top: 1em
}

.services-sub-title {
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
}

.overlay {
    background: #111;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 700px;
    opacity: 0.5;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 47%;

    }

    @media screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 15.6rem !important;

    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 15.4rem;

    }

    @media screen and (min-device-width: 412px) and (max-device-width: 914px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 16.4rem;

    }

    @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) {
        height: 37%;
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 604px;
    }

    @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {
        height: calc(32em + 5px);
    }
}

@media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {

    #host-service,
    #attend-service,
    #render-service {
        background: #FFFFFF;
        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
        border-radius: 24px;
        padding: 40px 10px;
    }

}
</style>
